import { isArray, mapValues, dropWhile, defer } from 'lodash';
import global from 'global';
import uuid from 'uuid';

const ORIGIN = Symbol('channel');
const TARGET = Symbol('terget');
const WINDOW = Symbol('window');
const SUBSCRIBERS = Symbol('sunscribers');
const READY = Symbol('ready');
const QUEUE = Symbol('queue');

// System messages
const PING = 'ping';
const PONG = 'pong';

const generateId = (prefix = '') => (`${prefix}-${uuid.v4()}`);

function onReady() {
  if (!this[READY]) {
    this[READY] = true;
    // flush queue
    while (this[QUEUE].length) {
      const { method, data } = this[QUEUE].pop();
      this.publish(method, data, true);
    }
    this[QUEUE] = [];
  }
}

export default class IframeTransport {
  constructor(target, currentWindow = global, origin = '*') {
    if (!target || !target.postMessage) {
      throw new Error('IframeTransport cannot run this browser, target not support postMessage');
    }

    if (!currentWindow || !currentWindow.addEventListener) {
      throw new Error('IframeTransport cannot run this browser, no addEventListener');
    }

    if (!currentWindow.JSON || !currentWindow.JSON.stringify || !currentWindow.JSON.parse) {
      throw new Error('IframeTransport cannot run this browser, no JSON parsing/serialization');
    }

    this[ORIGIN] = origin;
    this[TARGET] = target;
    this[WINDOW] = currentWindow;
    this[READY] = false;
    this[SUBSCRIBERS] = {};
    this[QUEUE] = [];
  }

  connect() {
    this.subscribe(PING, () => {
      this.publish(PONG, { ready: true }, true);
      onReady.call(this);
    });

    this.subscribe(PONG, ({ ready }) => {
      if (ready) {
        onReady.call(this);
      }
    });

    this[WINDOW].addEventListener('message', (event) => {
      try {
        const { method, data } = JSON.parse(event.data);
        if (this[SUBSCRIBERS][method] && isArray(this[SUBSCRIBERS][method])) {
          this[SUBSCRIBERS][method].map(({ callback }) => {
            if (typeof callback === 'function') {
              callback(data);
            }
            return null;
          });
        }
      } catch (ex) {
        // ignore
        // console.warn('Unable to parse JSON', ex);
      }
    }, false);

    defer(::this.publish, PING, {}, true);
  }

  publish(method, data, force = false) {
    if (!method) {
      throw new Error('IframeTransport cannot publish message with empty method');
    }

    if (force || this[READY]) {
      this[TARGET].postMessage(JSON.stringify({ method, data }), this[ORIGIN]);
    } else {
      this[QUEUE].push({ method, data });
    }
  }

  subscribe(method, callback) {
    if (!method) {
      throw new Error('IframeTransport cannot subscribe to empty method');
    }

    if (!this[SUBSCRIBERS][method]) {
      this[SUBSCRIBERS][method] = [];
    }

    const id = generateId();
    this[SUBSCRIBERS][method].push({ id, callback });

    return id;
  }

  unsubscribeAll(method) {
    if (this[SUBSCRIBERS][method]) {
      delete this[SUBSCRIBERS][method];
    }
  }

  unsubscribe(subscriberId) {
    if (subscriberId) {
      mapValues(this[SUBSCRIBERS],
        subscribers => dropWhile(subscribers, id => (id === subscriberId)));
    }
  }
}



// WEBPACK FOOTER //
// ./src/WebBridge/transport/IframeTransport.js